var _sodipodiNamedview, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 31.75 31.750002",
    id: "svg1696",
    inkscapeVersion: "1.1.1 (3bf5ae0d25, 2021-09-20)",
    sodipodiDocname: "golf.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1698",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapePageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    "inkscapeDocument-units": "px",
    showgrid: "false",
    inkscapeZoom: 4.3994184,
    inkscapeCx: 23.75314,
    inkscapeCy: 81.94265,
    "inkscapWindow-width": 2560,
    "inkscapeWindow-height": 1377,
    "inkscapeWindow-x": 1912,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "layer1",
    units: "px"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1693"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Ebene 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    style: {
      display: "inline"
    },
    transform: "translate(-0.03787441,-0.00135587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 11.120106,6.7114659 c -0.221897,-0.204259 -0.540455,-0.292806 -0.851958,-0.204611 l -1.8644309,0.528461 0.881239,-2.590095 c 0.159103,-0.468842 -0.09137,-0.977547 -0.559858,-1.137355 -0.468136,-0.159456 -0.977195,0.09137 -1.137003,0.559858 l -1.43122,4.206875 c -0.107244,0.315384 -0.03069,0.663928 0.198262,0.905581 0.172155,0.180975 0.408164,0.279047 0.650169,0.279047 0.08185,0 0.163689,-0.01094 0.244475,-0.03387 l 3.0331839,-0.859719 c 0.135466,-0.606425 0.440972,-1.185334 0.837141,-1.654175",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21.316443,26.137528 -3.249789,-6.611056 -1.001536,-3.459339 h -5.01015 l -1.819981,3.208514 c -0.05645,0.09948 -0.09842,0.207081 -0.124178,0.318558 l -1.5984359,6.874934 c -0.149931,0.642761 0.250472,1.284817 0.89288,1.434395 0.09102,0.02117 0.182034,0.0314 0.271639,0.0314 0.5425729,0 1.0343449,-0.372886 1.1627559,-0.924984 l 1.559278,-6.705953 1.6891,-2.97815 c 0.284692,0 0.569383,0 0.85337,0 l 0.859014,2.965803 c 0.0194,0.06668 0.04445,0.131939 0.07514,0.194733 l 3.296003,6.705601 c 0.207786,0.422627 0.632177,0.667808 1.07315,0.667808 0.176741,0 0.356658,-0.03951 0.526344,-0.122767 0.591961,-0.291041 0.836436,-1.006828 0.545395,-1.599494",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path892"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.415074,13.889436 c 0.519994,-1.697567 0.834319,-3.442759 0.668866,-5.1113981 -0.154164,-1.221669 -1.252361,-2.256367 -1.961444,-2.254956 -0.139348,0 -0.277636,0 -0.416631,0 -0.352425,0.14852 -0.733425,0.231775 -1.131711,0.231775 -0.05009,0 -0.100189,-0.0011 -0.150989,-0.0039 -0.34537,-0.01799 -0.674864,-0.09772 -0.98037,-0.227895 -0.12065,0 -0.240947,0 -0.36195,0 -0.709083,-0.0014 -1.80728,1.033287 -1.961797,2.254956 -0.1651,1.6686391 0.148167,3.4138311 0.668514,5.1113981 h 5.627512",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.700926,29.477275 c 0,0.893234 -0.724253,1.617487 -1.617839,1.617487 -0.893586,0 -1.617839,-0.724253 -1.617839,-1.617487 0,-0.893586 0.724253,-1.617486 1.617839,-1.617486 0.893586,0 1.617839,0.7239 1.617839,1.617486",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.838635,3.4366289 c -0.07267,1.400528 -1.133475,2.483556 -2.368551,2.419351 -1.23578,-0.06421 -2.178403,-1.25095 -2.10573,-2.651478 0.07267,-1.400528 1.133122,-2.48355602 2.368903,-2.41935002 1.23578,0.0642 2.17805,1.25130202 2.105378,2.65147702",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.783681,1.8392519 8.4428761,1.2056629 c -0.243064,-0.04621 -0.477662,0.113594 -0.523523,0.357011 -0.04657,0.243064 0.113242,0.477308 0.356659,0.523522 l 3.2480249,0.61595 c 0.05292,-0.303742 0.1397,-0.593372 0.259644,-0.862894",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27.515808,6.0020299 c -0.223662,-0.746125 -0.676276,-1.294695 -1.096787,-1.383948 -0.0081,-0.0025 -0.01552,-0.0056 -0.02399,-0.0074 l -8.669867,-1.644297 c 0.01446,0.169333 0.01799,0.341841 0.0085,0.516819 -0.0064,0.132292 -0.02187,0.261408 -0.04198,0.388761 l 7.982303,1.514123 c -0.04586,0.326672 -0.01411,0.725311 0.109009,1.135591 0.270933,0.90417 0.878769,1.520825 1.357136,1.377245 0.478719,-0.143581 0.646642,-0.992717 0.375708,-1.896886",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path902"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolf);
export default __webpack_public_path__ + "static/media/golf.6f89c1c92bb6bb102e20d946ddd81d3a.svg";
export { ForwardRef as ReactComponent };